<div class="d-flex" style="
display: flex !important;
justify-content: space-between;
width: 100%;
">
   <div class="mb-2 f-12 d-flex" style="width: 100%;">
      <div class="d-flex mr-2" style="
      display: flex !important;
      justify-content: flex-start;
      width: 100%;
  " *ngIf="previewAndOldDetails">
          <!-- <span *ngFor="let reveal of contactDetails; let i = index"> -->
              <!-- <i *ngIf="reveal?.is_revealed" [ngClass]="reveal.icon" class="mx-1 text-9696"
                  [title]="reveal.text"></i> -->
              <!-- <i class="fas fa-lock text-green mr-1"></i>
              <span class="text-9696 f-12" style="
    margin-top: -4px;>{{ reveal[i] }}</span>
          </span> -->

          <span *ngIf="canShowPhone">

              <span class="mr-2" *ngIf="phones && phones.length == 0; else showPhone">
                <i class="fas fa-lock text-green mr-1"></i>
                <span class="text-9696 f-12" style="
                   margin-top: -4px">Phone</span>
            </span>
            <ng-template #showPhone>
              <span id="contact_less_{{currrentIndex}}" style="display: block;">
                <span class="d-flex flex-column mr-4">
                  <span *ngFor="let phone of phones | slice:0:1;" class="d-flex align-items-center" style="margin:4px 0px">
                    <i class="mr-1 text-9696 fas fa-phone"></i>
                    <img [src]="'../../assets/icons/data-providers/' + phone.enrichedvia + '.png'" [alt]="phone.enrichedvia" style="width: 15px;  border-right: 3px solid #fff" *ngIf="phone.enrichedvia && (phone.enrichedvia !=='added-manually')">
                      <span class="f-12" style="margin-top: -4px">{{phone.contactdetail}}</span>
                  </span>
                </span>
              </span>

              <span id="contact_more_{{currrentIndex}}" style="display: none;">
                <span class="d-flex flex-column mr-4" >
                  <span *ngFor="let phone of phones" class="d-flex align-items-center" style="margin:4px 0px">
                    <i class="mr-1 text-9696 fas fa-phone"></i>
                    <img [src]="'../../assets/icons/data-providers/' + phone.enrichedvia + '.png'" [alt]="phone.enrichedvia" style="width: 15px;  border-right: 3px solid #fff" *ngIf="phone.enrichedvia && (phone.enrichedvia !== 'added-manually')">

                    <span class="f-12" style="margin-top: -4px">{{phone.contactdetail}}</span>
                  </span>
                </span>
              </span>
            </ng-template>

          </span>


          <span *ngIf="canShowPersonal_email">
            <span class="mr-2" *ngIf="personal_email && personal_email.length == 0; else showPersonalEmail">
              <i class="fas fa-lock text-green mr-1"></i>
               <span class="text-9696 f-12" style="
    margin-top: -4px">Personal Email</span>
           </span>
           <ng-template #showPersonalEmail>
            <span id="contact_less_{{currrentIndex}}" style="display: block;">
              <span class="d-flex flex-column mr-4">
                <span *ngFor="let email of personal_email | slice:0:1;" class="d-flex align-items-center" style="margin:4px 0px">
                  <i class="mr-1 text-9696 fas fa-envelope"></i>
                  <img [src]="'../../assets/icons/data-providers/' + email.enrichedvia + '.png'" [alt]="email.enrichedvia" style="width: 15px;  border-right: 3px solid #fff" *ngIf="email.enrichedvia && (email.enrichedvia !=='added-manually')">

                    <span class="f-12" style="
    margin-top: -4px" [matTooltip]="email.contactdetail" [matTooltipClass]="{ 'red-tooltip text-black': true }">{{ truncateString(email.contactdetail)}}</span>
                </span>
              </span>
            </span>

            <span id="contact_more_{{currrentIndex}}" style="display: none;">
              <span class="d-flex flex-column mr-4" >
                <span *ngFor="let email of personal_email" class="d-flex align-items-center" style="margin:4px 0px">
                  <i class="mr-1 text-9696 fas fa-envelope"></i>
                  <img [src]="'../../assets/icons/data-providers/' + email.enrichedvia + '.png'" [alt]="email.enrichedvia" style="width: 15px;  border-right: 3px solid #fff" *ngIf="email.enrichedvia && + (email.enrichedvia !=='added-manually')">

                  <span class="f-12" style="margin-top: -4px" [matTooltip]="email.contactdetail" [matTooltipClass]="{ 'red-tooltip text-black': true }">{{truncateString(email.contactdetail)}}</span>
                </span>
              </span>
            </span>

            </ng-template>
          </span>




          <span *ngIf="canShowWork_email">
            <span *ngIf="work_email && work_email.length == 0; else showProfessionalEmail">
              <i class="fas fa-lock text-green mr-1"></i>
               <span class="f-12" style="
    margin-top: -4px">Professional Email</span>
           </span>


       <ng-template #showProfessionalEmail>

        <span class="d-flex flex-column mr-4" >
          <span id="contact_less_{{currrentIndex}}" style="display: block;">
            <span class="d-flex flex-column mr-4">
              <span *ngFor="let email of work_email | slice:0:1;" class="d-flex align-items-center" style="margin:4px 0px">
                <i class="mr-1 text-9696 fas fa-briefcase"></i>
                <img [src]="'../../assets/icons/data-providers/' + email.enrichedvia + '.png'" [alt]="email.enrichedvia" style="width: 15px;  border-right: 3px solid #fff" *ngIf="email.enrichedvia && (email.enrichedvia !=='added-manually')">

                  <span class="f-12" style="
    margin-top: -4px" [matTooltip]="email.contactdetail" [matTooltipClass]="{ 'red-tooltip text-black': true }">{{truncateString(email.contactdetail)}}</span>
              </span>
            </span>
          </span>

          <span id="contact_more_{{currrentIndex}}" style="display: none;">
            <span class="d-flex flex-column mr-4" >
              <span *ngFor="let email of work_email" class="d-flex align-items-center" style="margin:4px 0px">
                <i class="mr-1 text-9696 fas fa-briefcase"></i>
                <img [src]="'../../assets/icons/data-providers/' + email.enrichedvia + '.png'" [alt]="email.enrichedvia" style="width: 15px;  border-right: 3px solid #fff" *ngIf="email.enrichedvia && (email.enrichedvia !=='added-manually')">
                <span class="f-12" style="
    margin-top: -2px" [matTooltip]="email.contactdetail" [matTooltipClass]="{ 'red-tooltip text-black': true }">{{truncateString(email.contactdetail)}}</span>
              </span>
            </span>
          </span>
        </span>


        <!-- <span *ngFor="let email of work_email">
          <span class="text-9696 f-12" style="
    margin-top: -4px"; style="
    margin-top: -4px;>{{email.contactdetail}}</span>
        </span> -->
      </ng-template>

          </span>


      </div>

      <span *ngIf="!isViewMoreClicked && totalContactsCount >= 1"
            class="f-12 text-webbtree-green pointer ml-2"
            (click)="viewmoredetails('contact', 'viewmore')"
            style="width: 150px;">
            + {{totalContactsCount}} more
      </span>

      <span *ngIf="isViewMoreClicked"
        class="f-12 text-webbtree-green pointer ml-2"
        (click)="viewmoredetails('contact', 'less')"
        style="width: 150px;">
        View Less
      </span>

      <span class="reveal-cand pointer" (click)="openContact()" style="margin-top: -2px;
      height: 30px;"
      *ngIf="!hideRevealContact && (!candidateInfo?.contactRevealStatus || candidateInfo?.contactRevealStatus == 'reveal-contact-notrevealed')">
          <!-- <i class="fas fa-unlock mr-1"></i>
          <span class="text-white">Reveal Contacts</span> -->

          <i class="fas fa-address-book mr-1"></i>
          <span class="">Explore Contacts</span>
      </span>
        <span class="" *ngIf="candidateInfo?.contactRevealStatus == 'reveal-contact-clicked' && (personal_email?.length == 0 && phones?.length == 0 && work_email?.length == 0)"><i class="fa-solid fa-magnifying-glass mr-1"></i> Finding Contact</span>

  </div>
</div>

